import { render } from "./SlaContents.vue?vue&type=template&id=6b5825be"
import script from "./SlaContents.vue?vue&type=script&lang=js"
export * from "./SlaContents.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__